import axios from "axios";

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://api.sigabrad.com.br/"
      : process.env.NODE_ENV === "homolog"
      ? "https://api-beta.sigabrad.com.br/"
      : process.env.NODE_ENV === "development"
      ? "http://localhost:8080/"
      : "",
});

export default instance;

if (process.env.NODE_ENV !== "production")
  console.log("ENV: " + process.env.NODE_ENV, instance.defaults.baseURL);

export const authHeader = (token) => {
  return { Authorization: `Bearer ${token}` };
};
